import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={33}
      height={41}
      viewBox="0 0 33 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M1.7 37.611c4.345 2.23 9.435 3.343 14.527 3.343 5.09 0 10.182-1.115 14.526-3.343a3.122 3.122 0 001.694-2.981 3.133 3.133 0 00-1.05-2.146c1.188-4.52-.152-9.824-3.913-15.109-1.364-1.917-3.032-3.785-4.672-5.393h-6.585c-1.879 0-3.62-.525-5.16-1.374-2.04 1.85-4.26 4.234-5.987 6.66-3.82 5.368-5.198 10.71-4.022 15.216-.61.537-.999 1.304-1.052 2.146a3.122 3.122 0 001.695 2.981z"
        fill="#333"
      />
      <Path
        d="M23.416 0H21.02a8.37 8.37 0 00-4.793 1.504A8.37 8.37 0 0011.434 0H9.038c-.663 0-1.199.536-1.199 1.198 0 4.625 3.763 8.388 8.388 8.388h7.19a3.599 3.599 0 013.594 3.594 1.198 1.198 0 102.396 0 5.998 5.998 0 00-5.99-5.99h-1.339a8.353 8.353 0 002.537-5.992C24.614.536 24.078 0 23.415 0z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
